module.exports = __webpack_public_path__ + "img/logo-mapfre.e3099e8c.svg";